import { useRequiredContext } from "@suse-o11y/use-required-context";
import { createContext } from "react";

interface UnmuteDrawerContextProps {
	ruleCount: number;
	ruleIndex: number;

	onSelect: (index: number) => void;

	onDelete: VoidFunction;
}

export const UnmuteDrawerContext = createContext<null | UnmuteDrawerContextProps>(null);

export const useUnmuteDrawerContext = () =>
	useRequiredContext(UnmuteDrawerContext, { providerName: "UnmuteDrawerContext" });
